import script from "./LoginRegistry.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginRegistry.vue?vue&type=script&setup=true&lang=js"

import "./LoginRegistry.vue?vue&type=style&index=0&id=bb8855e8&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb8855e8"]])

export default __exports__